import styled from 'styled-components'

export const Container = styled.div`
  height: 15em !important;
  width: 100% !important;
  zoom: 123% !important;
`

export const TooltipWrapper = styled.div`
  min-width: 200px;
  padding: 0.625em 0.625em 0.625em 0.625em !important;
  border-radius: 0.3125em !important;
  background-color: ${({ theme }) => theme.cor53}!important;
  color: ${({ theme }) => theme.cor54}!important;
  border: 1px solid ${({ theme }) => theme.cor59}!important;
`

export const TooltipContent = styled.div`
  display: grid;
  gap: 4px;
`

export const TituloTooltip = styled.h1`
  font-weight: 600;
  font-size: 14px;
`

export const TextTooltip = styled.span`
  font-weight: 500;
  font-size: 14px;
`

export const BlankSlateContainer = styled.div`
  padding-top: 30px;
  height: 305px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
